import React from 'react';
import { Paper, TextField, Typography } from '@mui/material';

interface CommentEditorProps {
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
}

const CommentEditor: React.FC<CommentEditorProps> = ({ value, onChange, required = false }) => (
  <Paper
    elevation={0}
    sx={{ p: 2, backgroundColor: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 1.5 }}
  >
    <Typography variant="subtitle2" fontWeight={600} sx={{ color: '#1e293b', mb: 1 }}>
      Comment {required && <span style={{ color: '#b45309' }}>(required)</span>}
    </Typography>
    <TextField
      fullWidth
      multiline
      rows={4}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={
        required
          ? 'A comment is required for this approval'
          : 'Optional comment (visible in audit trail)'
      }
      InputProps={{
        sx: {
          alignItems: 'flex-start',
          backgroundColor: '#ffffff',
          '& .MuiInputBase-input': { paddingTop: '8px' },
        },
      }}
    />
  </Paper>
);

export default CommentEditor;
